import axios from 'axios';
import { saveToken, delToken } from './TokenActions'
import { sidebarItemsActions } from './sidebarItemsAction';

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const DESTROY_SESSION = "DESTROY_SESSION";

// Requiring the lodash library  
const _ = require("lodash");

const LoginUserSuccess = User => ({
  type: LOGIN_USER_SUCCESS,
  payload: User
});


const LogoutUserSuccess = User => ({
  type: LOGOUT_USER_SUCCESS,
  payload: User
});

const UpdateUserSuccess = User => ({
  type: UPDATE_USER_SUCCESS,
  payload: User
});


let axiosConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "*",
  }
};
export const LoginUser = (UserCredentials, addToast) => {
  let _user = null;
  return async dispatch => {
    await axios.post(process.env.REACT_APP_ENDPOINT + "api/User/UserName", UserCredentials, axiosConfig)
      .then(res => res.data)
      .then(user => {

        addToast.success("Login Successfull");
        _user = _.omit(user, ['token']);
        return dispatch(saveToken(user.token));

        //  if(_user)
        //dispatch(sidebarItemsActions.getSidebarItems());
        //dispatch(LoginUserSuccess(user));

      })
      .catch(error => {
        //  if (error.response.status === 401) {
        addToast.error("Invalid Login Credentials");
        //  }
        //else {
       // console.log(error);
        // }

      });
    dispatch(LoginUserSuccess(_user));
  };
};



export const LogoutUser = (UserCredentials) => {
  return async dispatch => {
    //  console.log('Logout Ation');
    // console.log(SupplierCredentials);
    await dispatch(delToken());
    await dispatch(sidebarItemsActions.delSidebarItems());
    dispatch(LogoutUserSuccess(UserCredentials));
  };
};


export const UpdateUser = (UserCredentials) => {
  return dispatch => {
    //  console.log('Logout Ation');
    // console.log(SupplierCredentials);
    dispatch(UpdateUserSuccess(UserCredentials));
  };
};

export const onClear = () => {
  return { type: DESTROY_SESSION };
};
